import { useLayoutEffect, useRef, useState } from "react";
import ReactPlayer from "react-player/file";
import { api_getVideoSignedURL } from "../axios";
import { BasePlayer } from "./BasePlayer";

// Database video: the game (year/league/編號) comes from the shared 賽事
// selector (game prop), not a per-player form — so it stays in sync with the HUD.
export const HLSPlayer = ({playerRef, playing, onProgress, onDuration, onSourceChange, playbackRate, volume, game, children, ...sessionProps}) => {
  const [source, setSource] = useState({ url: "", version: 0 });
  const [urlError, setUrlError] = useState(null);
  const requestVersion = useRef(0);
  const requestedGame = useRef(null);
  const linkedGame = useRef(null);
  useLayoutEffect(() => () => { requestVersion.current += 1; }, []);

  const requestVideo = async (selectedGame) => {
    const g = selectedGame || {}
    if (!g.year || !g.league_id || !g.game_no) {
      alert("請先在上方「賽事」選擇 年份／聯賽／賽事編號")
      return
    }
    const version = ++requestVersion.current
    requestedGame.current = { ...g }
    setUrlError(null)
    try {
      const res = await api_getVideoSignedURL({object: `GameVideo/${g.year}/${g.league_id}/G${g.game_no}/G${g.game_no}.m3u8`})
      if (version !== requestVersion.current) return
      if (typeof res === "string" && res) {
        linkedGame.current = { ...g }
        setSource({ url: res, version })
      } else {
        setUrlError("連結影片失敗，請重試")
      }
    } catch {
      if (version === requestVersion.current) setUrlError("連結影片失敗，請重試")
    }
  }

  return (
    <BasePlayer
      {...sessionProps}
      Player={ReactPlayer}
      url={source.url}
      sourceVersion={source.version}
      playerRef={playerRef}
      playing={playing}
      onProgress={onProgress}
      onDuration={onDuration}
      onSourceChange={onSourceChange}
      onRetry={() => requestVideo(linkedGame.current)}
      playbackRate={playbackRate}
      volume={volume}
      config={{ file: { forceHLS: true } }}
      videoInput={
        <>
          <button onClick={() => requestVideo(game)}>連結資料庫影片</button>
          {urlError && (
            <span className="video-url-error" role="alert" style={{ color: "#f87171" }}>
              {urlError}
              <button type="button" onClick={() => requestVideo(requestedGame.current)}>重試</button>
            </span>
          )}
        </>
      }
    >
      {children}
    </BasePlayer>
  );
};
